import template from './testRoutes.html';
import controller from './testRoutes.controller';

let testRoutesComponent = {  
  controllerAs : 'ctrl',
  template,
  controller
};

export default testRoutesComponent;



// WEBPACK FOOTER //
// ./client/app/components/home/testRoutes/testRoutes.component.js